import ParameterErrors from '../errors/ParameterErrors';
import BrochureProgressStatus from '../enums/BrochureProgressStatus';
import BrochureBeingGenerated from './BrochureBeingGenerated';
import Urls from '../urls/Urls';
import GoogleAnalytics from '../google/GoogleAnalytics'; 
import Timer from '../core/Timer';
import eventEnable from '../core/eventEnable';
import SessionManager from '../sessions/SessionManager';
const {throwNotProvided}=ParameterErrors;
export default class BrochuresManager{
	constructor(params){
		eventEnable(this);
		this._brochuresBeingGenerated = [];
		this._mapBrochureGenerationIdentifierToBrochureBeingGenerated = new Map();
		this.setSessionTokenAndAddBrochureGenerationIdentifier_fromResponse_IfValid =
			this.setSessionTokenAndAddBrochureGenerationIdentifier_fromResponse_IfValid.bind(this);
		this._addBrochureBeingGenerated= this._addBrochureBeingGenerated.bind(this);
		this._getUpdatesToBrochureBeingGenerateds= this._getUpdatesToBrochureBeingGenerateds.bind(this);
		this._processUpdatesResponse= this._processUpdatesResponse.bind(this);
		this._processBrochuresResponse= this._processBrochuresResponse.bind(this);
		this._dispatchBrochuresBeingGeneratedChanged= this._dispatchBrochuresBeingGeneratedChanged.bind(this);
		this._clearBrochuresBeingGeneratedWhichAreNotComplete = this._clearBrochuresBeingGeneratedWhichAreNotComplete.bind(this);
		this._getBrochuresForSession= this._getBrochuresForSession.bind(this);
		this._timerGetUpdatesToBrochureBeingGenerateds = new Timer({
			delay:10000,
			callback:this._getUpdatesToBrochureBeingGenerateds, 
			nTicks:-1
		});
		this._getBrochuresForSession();
	}
	static get instance(){
		if(!BrochuresManager._instance)
			BrochuresManager._instance = new BrochuresManager();
		return BrochuresManager._instance;
	}
	generate({
		siteName, siteSlug, plotNumbers, title, firstName, surname, email, phoneNumber, optInOptions, agreedToFutureUpdates, agreedToPrivacyNotice, singlePlotBrochure,
		debug, pageGroupIdsToInclude
	}){
		return new Promise((resolve, reject)=>{
			const body = { 
				waitForUrl:false,
				siteName:siteSlug, 
				plotNumbers:plotNumbers, 
				debug,
				userInfo:{
					title,
					firstName,
					surname,
					email,
					phoneNumber,
					optInOptions,
					agreedToPrivacyNotice,
					agreedToFutureUpdates
				},
				sessionToken:SessionManager.instance.sessionToken,
				pageGroupIdsToInclude
			};
			if(email&&email.toLowerCase().indexOf('@futurium.co.uk')<0){
				if(singlePlotBrochure)
					GoogleAnalytics.logPlotBrochureRequest(siteName, plotNumbers[0].number);
				else 
					GoogleAnalytics.logFavouritesBrochureRequest(siteName);
			}
			fetch(Urls.getGeneratePDFBrochureSimple(this._configuration), {
					method: 'POST',    
					credentials: "same-origin",
					body:JSON.stringify(body)
			}).then((response) => {
				response.text().then(res => {
					const jObjectResponse = JSON.parse(res);
					this.setSessionTokenAndAddBrochureGenerationIdentifier_fromResponse_IfValid(jObjectResponse);
					resolve(jObjectResponse);
				}).catch(reject);
			}).catch(reject);
		});
	}
	setSessionTokenAndAddBrochureGenerationIdentifier_fromResponse_IfValid(jObjectResponse){
		if(jObjectResponse.sessionToken!==undefined&&jObjectResponse.sessionToken!==null){
			SessionManager.instance.sessionToken = jObjectResponse.sessionToken;
		}
		if(!jObjectResponse.brochureGenerationIdentifier)return;
		this._addBrochureBeingGenerated(new BrochureBeingGenerated({
			brochureGenerationIdentifier:jObjectResponse.brochureGenerationIdentifier,
			brochureType:jObjectResponse.brochureType,
			startedAt:jObjectResponse.startedAt,
			plotNumbers:jObjectResponse.plotNumbers,
			brochureUrl:jObjectResponse.brochureUrl
		}));
		this._timerGetUpdatesToBrochureBeingGenerateds.start();
	}
	_addBrochureBeingGenerated(brochureBeingGenerated){
		this._brochuresBeingGenerated.push(brochureBeingGenerated);
		this._mapBrochureGenerationIdentifierToBrochureBeingGenerated
			.set(brochureBeingGenerated.brochureGenerationIdentifier, brochureBeingGenerated);
		this._dispatchBrochuresBeingGeneratedChanged();
	}
	_getBrochuresForSession(){
			if(!SessionManager.instance.sessionTokenIsValid){
				SessionManager.instance.clearSessionToken();
				this._clearBrochuresBeingGeneratedWhichAreNotComplete();
				return;
			}
			const body = {
				sessionToken:SessionManager.instance.sessionToken
			};
			const url = Urls.getBrochureGenerationGetBrochuresForSession();
			fetch(url, {
				method: 'POST',    
				credentials: "same-origin",
				body:JSON.stringify(body)
			}).then((response) => {
				response.text().then(res => {
					const jObjectResponse = JSON.parse(res);
					this._processBrochuresResponse(jObjectResponse);
				}).catch(console.error);
			}).catch(console.error);
	}
	_getUpdatesToBrochureBeingGenerateds(){
		try{
			const brochureGenerationIdentifiersToGetUpdateFor = this._brochuresBeingGenerated
				.filter(brochureBeingGenerated=>brochureBeingGenerated.brochureProgressStatus!==BrochureProgressStatus.Generated)
				.map(brochureBeingGenerated=>brochureBeingGenerated.brochureGenerationIdentifier);
			if(brochureGenerationIdentifiersToGetUpdateFor.length<1){
				this._timerGetUpdatesToBrochureBeingGenerateds.reset();
				return;
			}
			if(!SessionManager.instance.sessionTokenIsValid){
				SessionManager.instance.clearSessionToken();
				this._clearBrochuresBeingGeneratedWhichAreNotComplete();
				return;
			}
			const body = {
				brochureGenerationIdentifiers:brochureGenerationIdentifiersToGetUpdateFor,
				sessionToken:SessionManager.instance.sessionToken
			};
			const url = Urls.getBrochureGenerationCheckProgress();
			fetch(url, {
				method: 'POST',    
				credentials: "same-origin",
				body:JSON.stringify(body)
			}).then((response) => {
				response.text().then(res => {
					const jObjectResponse = JSON.parse(res);
					this._processUpdatesResponse(jObjectResponse);
				}).catch(console.error);
			}).catch(console.error);
		}
		catch(err){
			console.error(err);
		}		
	}
	_processBrochuresResponse(jObjectResponse){
		jObjectResponse.progresses?.forEach(progress=>{
			let brochureBeingGenerated = this._mapBrochureGenerationIdentifierToBrochureBeingGenerated.get(
				progress.brochureGenerationIdentifier);
			if(!brochureBeingGenerated){
				brochureBeingGenerated = new BrochureBeingGenerated(progress);
				this._addBrochureBeingGenerated(brochureBeingGenerated);
			}
			else
				brochureBeingGenerated.updateProgress(progress);
		});
	}
	_processUpdatesResponse(jObjectResponse){
		if(jObjectResponse.sessionTimedOut){
			this._clearBrochuresBeingGeneratedWhichAreNotComplete();
			return;
		}
		jObjectResponse.progresses.forEach(progress=>{
			const brochureBeingGenerated = this._mapBrochureGenerationIdentifierToBrochureBeingGenerated.get(progress.brochureGenerationIdentifier);
			if(!brochureBeingGenerated)return;
			brochureBeingGenerated.updateProgress(progress);
		});
	}
	_clearBrochuresBeingGeneratedWhichAreNotComplete(){
		const newBrochuresBeingGenerated =[];
		const toRemove = [];
		this._brochuresBeingGenerated.forEach(brochureBeingGenerated=> {
			if(brochureBeingGenerated.brochureProgressStatus===BrochureProgressStatus.Generated)
				newBrochuresBeingGenerated.push(brochureBeingGenerated);
			else 
				toRemove.push(brochureBeingGenerated);
		});
		toRemove.forEach(brochureBeingGenerated=>
			this._mapBrochureGenerationIdentifierToBrochureBeingGenerated.delete(brochureBeingGenerated.brochureGenerationIdentifier)
		);
		this._brochuresBeingGenerated = newBrochuresBeingGenerated;
		this._dispatchBrochuresBeingGeneratedChanged();
	}
	_dispatchBrochuresBeingGeneratedChanged(){
		this.dispatchEvent({type:'brochuresBeingGeneratedChanged', brochuresBeingGenerated:this._brochuresBeingGenerated});
	}
}